/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ResourceType = 'STATIC' | 'DYNAMIC';

export const ResourceType = {

    STATIC: 'STATIC' as ResourceType,

    DYNAMIC: 'DYNAMIC' as ResourceType
};

